<template>
  <div class="list-inputs-combobox">
    <v-combobox
      :label="label"
      v-model="combobox"
      multiple
      chips
      solo
      :deletable-chips="false"
      ref="combobox"
      persistent-hint
      prepend-inner-icon="mdi-arrow-right-thick"
      :hint="hint"
      hide-selected
    >
      <template v-slot:selection="{ item, index }">
        <v-chip color="grey darken-3" dark label class="mr-1 mb-1 pr-2" :class="index === 0 ? 'ml-0' : ''">
          {{ item }}
          <v-btn x-small icon class="ml-3" @click="editItemOpen(index)">
            <v-icon size="15">mdi-pencil</v-icon>
          </v-btn>
          <v-btn x-small icon @click="removeItemOpen(index)">
            <v-icon size="15">mdi-delete</v-icon>
          </v-btn>
        </v-chip>
        <span v-if="combobox.length - 1 === index">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip v-on="on" v-bind="attrs" color="grey darken-3" dark label class="mr-1 mb-1 px-3" @click="addItemOpen">
                <v-icon size="17">mdi-plus-circle</v-icon>
              </v-chip>
            </template>
            <span>{{$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.QUALIFICATION_COMBOBOX.SET_VALUE_BTN')}}</span>
          </v-tooltip>
        </span>
      </template>
    </v-combobox>

    <!-- Add Item -->
    <v-dialog v-model="add.dialog" max-width="500">
      <v-text-field ref="addItemText" :label="$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.QUALIFICATION_COMBOBOX.SET_VALUE_LABEL')" v-model="add.field" solo dense hide-details>
        <template #append>
          <v-tooltip bottom color="info">
            <template #activator="{on, attrs}">
              <v-btn v-on="on" v-bind="attrs" color="info" class="mr-2" fab x-small @click="addItem">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>{{$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.QUALIFICATION_COMBOBOX.SET')}}</span>
          </v-tooltip>
          <v-tooltip bottom color="error">
            <template #activator="{on, attrs}">
              <v-btn v-on="on" v-bind="attrs" color="error" fab x-small @click="add.dialog = false">
                <v-icon>mdi-cancel</v-icon>
              </v-btn>
            </template>
            <span>{{$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.QUALIFICATION_COMBOBOX.CANCEL')}}</span>
          </v-tooltip>
        </template>
      </v-text-field>
    </v-dialog>
    <!-- ./Add Item -->

    <!-- Edit Item -->
    <v-dialog v-model="edit.dialog" max-width="500">
      <v-text-field :label="$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.QUALIFICATION_COMBOBOX.EDIT_VALUE_LABEL')" v-model="edit.field" solo dense hide-details>
        <template #append>
          <v-tooltip bottom color="success">
            <template #activator="{on, attrs}">
              <v-btn v-on="on" v-bind="attrs" color="success" class="mr-2" fab x-small @click="editItem">
                <v-icon>mdi-check</v-icon>
              </v-btn>
            </template>
            <span>{{$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.QUALIFICATION_COMBOBOX.SAVE')}}</span>
          </v-tooltip>
          <v-tooltip bottom color="error">
            <template #activator="{on, attrs}">
              <v-btn v-on="on" v-bind="attrs" color="error" fab x-small @click="edit.dialog = false">
                <v-icon>mdi-cancel</v-icon>
              </v-btn>
            </template>
            <span>{{$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.QUALIFICATION_COMBOBOX.CANCEL')}}</span>
          </v-tooltip>
        </template>
      </v-text-field>
    </v-dialog>
    <!-- ./Edit Item -->

    <!-- Remove Item -->
    <v-dialog v-model="remove.dialog" max-width="500">
      <v-card>
        <div class="d-flex justify-space-between align-center px-3 py-2">
          <div class="text-subtitle-2">
            <v-icon left color="red darken-2">mdi-alert</v-icon>
            {{$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.QUALIFICATION_COMBOBOX.WARN_TEXT')}}
          </div>
          <div>
            <v-tooltip bottom color="info">
              <template #activator="{on, attrs}">
                <v-btn v-on="on" v-bind="attrs" color="info" class="mr-2" fab x-small @click="removeItem">
                  <v-icon>mdi-check</v-icon>
                </v-btn>
              </template>
              <span>{{$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.QUALIFICATION_COMBOBOX.REMOVE')}}</span>
            </v-tooltip>
            <v-tooltip bottom color="error">
              <template #activator="{on, attrs}">
                <v-btn v-on="on" v-bind="attrs" color="error" fab x-small @click="remove.dialog = false">
                  <v-icon>mdi-cancel</v-icon>
                </v-btn>
              </template>
              <span>{{$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.QUALIFICATION_COMBOBOX.CANCEL')}}</span>
            </v-tooltip>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <!-- ./Remove Item -->
  </div>
</template>

<script>
export default {
  name: "UrunNitelikEkle",
  props: {
    value: {
      type: Array,
      default: []
    },
    label: {
      type: String,
      default: ""
    },
    hint: {
      type: String
    }
  },
  data() {
    return {
      add: {
        dialog: false,
        field: ""
      },
      edit: {
        dialog: false,
        field: "",
        index: null
      },
      remove: {
        dialog: false,
        index: null
      },
      combobox: [],
      comboboxEditKey: "",
      comboboxEditItem: "",
      comboboxEditField: "",
      activatorID: "",
      activator: false
    };
  },
  methods: {
    editItem() {
      this.$set(this.combobox, this.edit.index, this.edit.field);
      this.edit.dialog = false;
    },
    editItemOpen(index) {
      this.edit.field = this.combobox[index];
      this.edit.index = index;
      this.edit.dialog = true;
    },
    removeItem() {
      this.combobox.splice(this.removeItem.index, 1);
      this.remove.dialog = false;
    },
    removeItemOpen(index) {
      this.remove.index = index;
      this.remove.dialog = true;
    },
    comboboxEdit(index, item) {
      if (!this.editingCombobox) {
        this.editingCombobox = item;
        this.editingIndexCombobox = index;
      } else {
        this.editingCombobox = null;
        this.editingIndexCombobox = -1;
      }
    },
    addItemOpen() {
      this.add.dialog = true;
    },
    addItem() {
      if (!this.combobox.includes(this.add.field)) {
        this.combobox.push(this.add.field);
      }
      this.add.dialog = false;
    },
    isEditing(key) {
      return this.comboboxEditKey === key;
    },
    colorboxChanged(items) {
      this.combobox = items;
    }
  },
  created() {
    this.combobox = this.value;

    this.activatorID = Math.floor(Math.random() * 55000);
  },
  watch: {
    combobox(value) {
      this.$emit("input", value);

      if (!value.length) {
        this.activator = false;
      }
    },
    value(value) {
      this.combobox = value;
    }
  }
};
</script>

<style>
.combobox-combobox {
  position: relative;
}

.combobox-list-item {
  min-height: 30px;
}

.combobox-list-item .v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
  min-height: auto;
}

.combobox-list-item .v-text-field.v-text-field--solo.v-input--dense .v-input__slot {
  padding: 0;
}

.combobox-list-item:last-child .v-divider {
  display: none;
}
</style>
